import { apiService } from './apiService';

export interface UIConfiguration {
  autoRefreshIntervalSeconds: number;
  enableAutoRefresh: boolean;
  refreshOnlyWhenVisible: boolean;
}

class ConfigurationService {
  private uiConfig: UIConfiguration | null = null;

  async getUIConfiguration(): Promise<UIConfiguration> {
    if (!this.uiConfig) {
      try {
        this.uiConfig = await apiService.get<UIConfiguration>('/configuration/ui');
      } catch (error) {
        console.warn('Failed to fetch UI configuration, using defaults:', error);
        // Return sensible defaults if the API fails
        this.uiConfig = {
          autoRefreshIntervalSeconds: 10,
          enableAutoRefresh: true,
          refreshOnlyWhenVisible: true
        };
      }
    }
    return this.uiConfig;
  }

  // Allow refreshing the configuration if needed
  async refreshUIConfiguration(): Promise<UIConfiguration> {
    this.uiConfig = null;
    return this.getUIConfiguration();
  }
}

export const configurationService = new ConfigurationService();